module.exports = __webpack_public_path__ + "fonts/Rubik-BoldItalic.8aa7fa4b.ttf";